import { $authHost } from "./index";

export const getContracts = async () => {
  const { data } = await $authHost.get("/api/contracts");

  return data;
};

export const getContract = async (id) => {
  const { data } = await $authHost.get(`/api/contracts/${id}`);

  return data;
};

export const updateContract = async (id, body) => {
  const { data } = await $authHost.put(`/api/contracts/${id}`, body);

  return data;
};

export const createContract = async (body) => {
  const { data } = await $authHost.post("/api/contracts", body);

  return data;
};
export const deleteContract = async (id) => {
  const { data } = await $authHost.delete(`/api/contracts/${id}`);

  return data;
};
